import styled from 'styled-components';
import { rem } from 'polished';
import { TooltipStyled } from '../TooltipStyled';

export const TooltipStyledDS = styled(TooltipStyled)`
    .tooltip-box {
        font-size: ${rem('10px')} !important;
        width: fit-content !important;
        padding: 0 ${rem('3px')} !important;
        margin-left: 0 !important;
        line-height: ${rem('15px')} !important;
        &-basket {
            font-size: ${rem('13px')} !important;
            padding: 0 ${rem('9px')} !important;
            margin: 0 !important;
        }
    }
`;
